<template>
  <div class="dt-row" >
    <!-- New row -->
    <div class="dt-row-detail active" :id="'searchBoxContainer-' + item.index">
      <div class="body-col event-name"
           :style="{ width: columnWidth.eventName.size ? (columnWidth.eventName.size + 'px') : '12%' }" block
           v-if="columnWidth.eventName.show">
        <div class="client-name">
          <span v-if="viewMode != 'Client'">{{item.clientName}}</span>
        </div>
        <div class="name">
          <div class="icon-expand" @click="setExpandId(); item.showCollapse = !item.showCollapse;"
               :class="(item.id != expandId) ? 'collapsed' : null" :aria-controls="accordionId"
               :aria-expanded="(item.id === expandId) ? 'true' : 'false'">
            <div v-if="item.status === 'DRAFTS'" class="icon-draft"></div>
            <div v-if="item.status === 'SUBMITTED'" class="icon-submitted"></div>
            <div v-if="item.status === 'REVIEW'" class="icon-review"></div>
            <div v-if="item.status === 'APPROVED'" class="icon-approved"></div>
            <div v-if="item.status === 'ARCHIVED'" class="icon-archived"></div>
          </div>
          <span class="icon-circle">
            <Icon v-if="item.isChangeOrder" name="exclamation-circle"
                  class="row-detail-icon row-detail-icon-exclamation-circle circle-red"></Icon>
          </span>
          <input v-if="isEM && eventStatus.toLowerCase() == listEventStatus.approved"
                 class="data-table-row-edit-mode-text data-table-row-edit-mode-input-small" v-model="item.eventName"
                 @blur="eventNameBlur(eventFields.eventName); unlockEvent();" v-on:focus="lockEvent()"
                 :disabled="isLocked" />
          <span class="event-name-no-edit" v-else>{{ item.eventName || eventName }}</span>
        </div>
      </div>
      <!-- prefDate -->
      <div class="body-col overflow-show"
           :style="{ width: columnWidth.prefDate.size ? (columnWidth.prefDate.size + 'px') : '9%' }"
           v-if="columnWidth.prefDate.show">
        <div class="data-table-icon-circle" :style="requiredPrefDate ? {display: 'block'} : ''">
          <Icon v-if="requiredPrefDate" name="exclamation-circle"
                class="row-detail-icon row-detail-icon-exclamation-circle"></Icon>
        </div>
        <div class="pref-date-body-col label-text" :class="{'place-holder': !item.prefDate}" @click="toggleShowDateTimePicker();">{{item.prefDate ? item.prefDate : 'MM/DD/YYYY'}}</div>
        <div style="position: absolute; right: 206px; top: 64px;" v-if="showDateTimePicker">
          <CalendarDatePickerDataTable :showLeft="true"
                                       :lockedDates="lockedDates"
                                       :dateRangeHasData="dateRangeHasData"
                                       :selectedDate="selectedDate"
                                       :value="item.prefDate"
                                       v-on:getDateRangeHasData="getDateRangeHasData"
                                       v-on:input="selectDate"
                                       v-on:selectDate="setSelected"
                                       :disabled="!editable || isLocked || isUpdating"
          ></CalendarDatePickerDataTable>
        </div>
      </div>
      <!-- projPart -->
      <div class="body-col" :style="{ width: columnWidth.projPart.size ? (columnWidth.projPart.size + 'px') : '5%' }"
           v-if="columnWidth.projPart.show">
        <div class="data-table-icon-circle"
             :style="(enableIconProjPart && !isCreateByEM) ||requiredProjPart ? {display: 'block'} : ''">
          <Icon v-if="(enableIconProjPart && !isCreateByEM) || requiredProjPart" name="exclamation-circle"
                class="row-detail-icon row-detail-icon-exclamation-circle"></Icon>
        </div>
        <input v-model="item.projPart" class="data-table-row-edit-mode-text data-table-row-edit-mode-input-small"
               @blur="unlockEvent(); saveEvent()" v-on:focus="lockEvent()" placeholder="100" type="number"
               :disabled="!editable || isLocked || isUpdating"/>
      </div>
      <!-- fullAddress -->
      <div class="body-col body-col-address-bing"
           :style="{ width: columnWidth.fullAddress.size ? (columnWidth.fullAddress.size + 'px') : '19%' }"
           v-if="columnWidth.fullAddress.show">
        <div v-if="requiredAddress" class="data-table-icon-circle" :style="requiredAddress ? {display: 'block'} : ''">
          <Icon name="exclamation-circle" class="row-detail-icon row-detail-icon-exclamation-circle"></Icon>
        </div>
        <vue-google-autocomplete name="address-input"
                                 v-if="!isUsedBingMap"
                                 :style="requiredAddress ? {'margin-left': '5px' } : ''"
                                 :id="'map_' + index + '-' + showOnModal"
                                 :classname="'form-control data-table-row-edit-mode-text address-input' + (isAddressError ? ' address-error' : '')"
                                 placeholder="Address"
                                 v-on:placechanged="setPlace"
                                 @blur="unlockEvent()"
                                 v-on:focus="lockEvent()"
                                 :country="['us']" :item="item"
                                 :disabled="!editable || isLocked || isUpdating"
                                 v-on:change="getValue"></vue-google-autocomplete>
        <div v-if="isUsedBingMap">
          <label :for="'searchBox-' + showOnModal + '-' + item.index"></label>
          <input type='text' :id="'searchBox-' + showOnModal + '-' + item.index"
               @blur="unlockEvent()"
               v-on:focus="lockEvent()"
               placeholder="Address"
               v-model="item.fullAddress"
               class="address-input-bing data-table-row-edit-mode-text"
               :disabled="!editable || isLocked || isUpdating"/>
        </div>
        <span v-if="isAddressError" class="address-error-message">{{addressErrorMessage()}}</span>
      </div>
      <!-- Building -->
      <div class="body-col"
           :style="{ width: columnWidth.building.size ? (columnWidth.building.size + 'px') : '7%' }"
           v-if="columnWidth.building.show">
        <input v-model="item.building" class="data-table-row-edit-mode-text" @blur="unlockEvent(); saveEvent()"
               v-on:focus="lockEvent()"
               placeholder="Building" :disabled="!editable || isLocked || isUpdating"/>
      </div>
      <!-- eventLocation -->
      <div class="body-col"
           :style="{ width: columnWidth.eventLocation.size ? (columnWidth.eventLocation.size + 'px') : '7%' }"
           v-if="columnWidth.eventLocation.show">
        <div v-if="requiredLocation" class="data-table-icon-circle" :style="requiredLocation ? {display: 'block'} : ''">
          <Icon name="exclamation-circle" class="row-detail-icon row-detail-icon-exclamation-circle"></Icon>
        </div>
        <input v-model="item.eventLocation" class="data-table-row-edit-mode-text" @blur="unlockEvent(); saveEvent()"
               v-on:focus="lockEvent()"
               placeholder="Location" :disabled="!editable || isLocked || isUpdating"/>
      </div>
      <!-- startTime -->
      <div class="body-col overflow-show show-dropdown"
           :style="{ width: columnWidth.startTime.size ? (columnWidth.startTime.size + 'px') : '7%' }"
           @click="toggleShowTimePicker()">
        <div class="data-table-icon-circle" :style="requiredStartTime ? {display: 'block'} : ''">
          <Icon v-if="requiredStartTime" name="exclamation-circle"
                class="row-detail-icon row-detail-icon-exclamation-circle"></Icon>
        </div>
        <template v-if="editable">
          <dropdown :options="listTime" class="label-text" :class="{'place-holder': !item.startTime}"
                    :selected="{name: item.startTime ? item.startTime : undefined}"
                    v-on:updateOption="setStartTime"
                    :placeholder="'Start time'">
          </dropdown>
        </template>
        <template v-else>
          <span>{{ item.startTime }}</span>
        </template>
      </div>
      <!-- duration -->
      <div class="body-col" :style="{width: columnWidth.duration.size ? (columnWidth.duration.size + 'px') : '5%',
      'padding-right': item.duration.length > 2 ? '5px' : '10px'}">
        <div class="data-table-icon-circle"
             :style="((enableIconDuration && !isCreateByEM) || requiredDuration) ? {display: 'block'} : ''">
          <Icon v-if="((enableIconDuration && !isCreateByEM) || requiredDuration)" name="exclamation-circle"
                class="row-detail-icon row-detail-icon-exclamation-circle"></Icon>
        </div>
        <!-- <span>{{ calculateDuration }}</span> -->
        <input v-if="isEM" :style="item.duration.length > 2 ? {width: '22px'} : {width: '15px'}" v-model="item.duration"
               class="data-table-row-edit-mode-text"
               @blur="unlockEvent(); durationBlur(eventFields.duration)" v-on:focus="lockEvent()" placeholder="0"
               type="number" step="any" :disabled="!editable || isLocked || isUpdating"/>
        <input v-else :style="item.duration.length > 2 ? {width: '22px'} : {width: '15px'}" v-model="item.duration"
               class="data-table-row-edit-mode-text"
               @blur="unlockEvent(); durationBlur(eventFields.duration)" v-on:focus="lockEvent()" placeholder="0"
               type="number" step="any" :disabled="!editable || isLocked || disableDuration"/>
        <span v-if="item.duration > 0" style="margin-left: -3px;">HR</span>
      </div>
      <!-- endTime -->
      <div class="body-col col-end-time" :style="{ width: columnWidth.endTime.size ? (columnWidth.endTime.size + 'px') : '7%' }">
        <span class="label-text" :class="{'place-holder': !item.startTime}" >{{calculateTimeEnd}}</span>
      </div>
      <!-- timeZone -->
      <div class="body-col" :style="{ width: columnWidth.timeZone.size ? (columnWidth.timeZone.size + 'px') : '4%' }">
        <input v-model="item.timeZone" class="data-table-row-edit-mode-text" @blur="unlockEvent(); saveEvent()"
               v-on:focus="lockEvent()" placeholder="EST"
               :disabled="!editable || isLocked || isUpdating"/>
      </div>
      <!-- contact -->
      <div class="body-col overflow-show"
           :style="{ width: columnWidth.contactName.size ? (columnWidth.contactName.size + 'px') : '9%' }">
        <div class="data-table-icon-circle"
             :style="((disableIconContact && !isCreateByEM) || requiredContactName) ? {display: 'block'} : ''">
          <Icon v-if="(disableIconContact && !isCreateByEM) || requiredContactName" name="exclamation-circle"
                class="row-detail-icon row-detail-icon-exclamation-circle"></Icon>
        </div>
        <multiselect v-if="editable || !isLocked"
                     :style="((disableIconContact && !isCreateByEM) || requiredContactName) ? {'margin-left': '8px' } : ''"
                     v-model="item.contact" :options="onSiteContacts" :placeholder="'Select contact'" @open="lockEvent()"
                     @search-change="searchContact"
                     @input="selectOnSiteContact" :value="item.contactName" label="contactName" class="col-contact"
                     :allow-empty="true" :show-no-results="false" :searchable="!isLocked" :show-labels="false"
                     @close="closeOnsiteContact ">
          <template slot="option" slot-scope="props">
            <div class="contact-detail">
              <span class="contact-name-decoration" v-html="props.option.contactNameDecoration"></span><br/>
              <span>
                {{props.option.contactEmail ? props.option.contactEmail : 'N/A'}} ,
                {{props.option.contactPhone ? props.option.contactPhone : 'N/A'}}</span>
            </div>
          </template>
        </multiselect>
        <template v-else>
          <span>{{ item.contactName }}</span>
        </template>
      </div>

      <!-- action -->
      <div class="body-col" :style="{ width: columnWidth.action.size ? (columnWidth.action.size + 'px') : '9%' }">
        <div v-if="viewMode === 'Client'">
          <div v-if="!item.showCollapse && eventStatus == listEventStatus.drafts">
            <div class="icon-wrapper">
              <div class="icon-delete" v-b-tooltip.hover.bottom @click="deleteEventClick()" :title="instructions.delete" :name="iconNames.trashO"></div>
            </div>
            <div class="icon-wrapper">
              <div class="icon-duplicate" v-b-tooltip.hover.bottom @click="duplicateEventClick()" :title="instructions.duplicated" :name="iconNames.repeat"></div>
            </div>
            <div class="icon-wrapper">
              <div class="icon-submit" v-b-tooltip.hover.bottom @click="submitEventClick()" :title="instructions.submit" :name="iconNames.chevronRight"></div>
            </div>
          </div>
          <div
            v-if="!item.showCollapse && (eventStatus == listEventStatus.submitted || eventStatus == listEventStatus.review)">
            <span :style="{visibility: 'hidden'}">
                <Icon :name="iconNames.repeat" class="row-detail-icon fa-fw icon-actions"></Icon>
              </span>
            <span @click="rowActionMiddleClick()" v-if="isEM">
              <Icon :name="iconNames.chevronRight" class="row-detail-icon fa-fw icon-actions"></Icon>
            </span>
          </div>
          <div v-if="eventStatus == listEventStatus.approved && !isReadOnly">
            <span class="action-change-order" @click="btnChangeOrderClick()">
              Change Order
            </span>
          </div>
          <div v-if="!item.showCollapse && (eventStatus == listEventStatus.archived)">
            <span @click="deleteEventClick()">
              <Icon v-b-tooltip.hover.bottom :title="instructions.delete" :name="iconNames.trashO"
                    class="row-detail-icon fa-fw icon-actions"></Icon>
            </span>
            <span @click="restoreEvent()">
              <Icon v-b-tooltip.hover.bottom :title="instructions.restoreToDrafts" :name="iconNames.refresh"
                    class="row-detail-icon fa-fw icon-actions"></Icon>
            </span>
          </div>
        </div>
        <div v-else>
          <RowStatus :eventStatus="item.status"></RowStatus>
        </div>
      </div>
    </div >
    <!-- ROW DETAIL -->
    <b-collapse :id="accordionId" v-model="item.showCollapse" accordion="datatable-accordion">
      <div class="dt-row-item-detail">
        <div class="item-detail-header">
          <div class="row">
            <div class="col-sm-3 padding-left-50">alerts</div>
            <div class="col-sm-4 padding-left-22">event notes</div>
            <div class="col-sm-3">on site contact</div>
            <div class="col-sm-2">add on services</div>
          </div>
        </div>
        <div class="item-detail-body">
          <div class="row">
            <div class="col-sm-3">
              <div v-if="item.isChangeOrder" class="row li-red">
                <div class="col-sm-1 icon-alert">
                  <Icon name="exclamation-circle"
                        class="row-detail-icon row-detail-icon-exclamation-circle circle-red"></Icon>
                </div>
                <div class="col-sm-11 text-alert">
                  <span class="alert-note">This item approved as a change order. Check change notes and contract details.</span>
                </div>
              </div>
              <div v-if="item.projPart < 33 && !isCreateByEM" class="row">
                <div class="col-sm-1 icon-alert">
                  <Icon name="exclamation-circle" class="row-detail-icon row-detail-icon-exclamation-circle"></Icon>
                </div>
                <div class="col-sm-11 text-alert">
                  <span class="alert-note">Your estimated participation is low. Consider using small site event.</span>
                </div>
              </div>
              <div v-if="item.projPart > 200 && !isCreateByEM" class="row">
                <div class="col-sm-1 icon-alert">
                  <Icon name="exclamation-circle" class="row-detail-icon row-detail-icon-exclamation-circle"></Icon>
                </div>
                <div class="col-sm-11 text-alert">
                  <span class="alert-note">Your estimated participation is high. Break event into 2 days.</span>
                </div>
              </div>
              <div v-if="disableIconContact && !isCreateByEM" class="row">
                <div class="col-sm-1 icon-alert">
                  <Icon name="exclamation-circle" class="row-detail-icon row-detail-icon-exclamation-circle"></Icon>
                </div>
                <div class="col-sm-11 text-alert">
                  <span
                    class="alert-note">Missing (email, phone number, email and phone number) for on site contact.</span>
                </div>
              </div>
              <div v-if="enableIconDuration" class="row">
                <div class="col-sm-1 icon-alert">
                  <Icon name="exclamation-circle" class="row-detail-icon row-detail-icon-exclamation-circle"></Icon>
                </div>
                <div class="col-sm-11 text-alert">
                  <span class="alert-note">Standard events can only be submitted with durations between 4 - 8 hours. To request an event outside of this range please contact ADURO.</span>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="notes-field">
                <div class="text-label">
                  shipping address
                  <span class="grey-3 label-address">(if different than event address)</span>
                </div>
                <div class="text-value">
                  <vue-google-autocomplete name="shipping-address" :id="'shipping_' + index + '-' + showOnModal"
                                           v-if="!isUsedBingMap"
                                           classname="additional-comments shipping-address"
                                           placeholder="Shipping address"
                                           v-on:placechanged="modifyShippingAddress" @blur="unlockEvent();"
                                           v-on:focus="lockEvent()"
                                           :country="['us']" :item="item"
                                           :disabled="!editable || isLocked || isUpdating"></vue-google-autocomplete>
                  <div :id="'searchBoxForShippingAddressContainer-' + item.index" v-if="isUsedBingMap">
                    <label :for="'searchBoxForShippingAddress-' + showOnModal + '-' + item.index"></label>
                    <input type='text' :id="'searchBoxForShippingAddress-' + showOnModal + '-' + item.index"
                           @blur="unlockEvent();"
                           v-on:focus="lockEvent()"
                           placeholder="Shipping address"
                           v-model="item.shippingAddress"
                           class="additional-comments shipping-address"
                           :disabled="!editable || isLocked || isUpdating"/>
                  </div>
                </div>
              </div>
              <div class="notes-field">
                <div class="text-label">
                  custom event notes
                </div>
                <div class="text-value">
                  <textarea v-model="item.customEventNote" @blur="unlockEvent()" v-on:focus="lockEvent()"
                            name="custom-notes" class="custom-notes" placeholder="E.g. add ons, extra staff, etc"
                            :disabled="!editable || isLocked || isUpdating"></textarea>
                </div>
              </div>
              <div class="notes-field">
                <div class="text-label">
                  Additional comments ({{item.additionalComments ? item.additionalComments.length : 0}}/1000)
                </div>
                <div class="text-value">
                  <textarea name="additional-comments" @blur="unlockEvent()" v-on:focus="lockEvent()"
                            v-model="item.additionalComments" class="additional-comments"
                            placeholder="E.g. instructions from client or change documentation"
                            :disabled="!editable || isLocked || isUpdating"></textarea>
                </div>
              </div>
              <div class="notes-field">
                <div class="text-label">
                  On Site Instructions
                </div>
                <div class="text-value">
                  <input v-model="item.onsiteInstruction" class="additional-comments shipping-address"/>
                </div>
              </div>
              <div class="notes-field">
                <div class="text-label">
                  Parking Information
                </div>
                <div class="text-value">
                  <input class="additional-comments shipping-address" v-model="item.parkingInformation"/>
                </div>
                <div class="arrival-time">
                  <div class="text-label">ADURO Arrival Time:</div>
                  <div class="show-dropdown-for-arrival-time">
                    <template v-if="editable">
                      <dropdown ref="arrivalTime" :options="listTime"
                                :selected="arrivalTime"
                                v-on:updateOption="setAduroArrivalTime"
                                :placeholder="'Set Time'">
                      </dropdown>
                    </template>
                    <template v-else>
                      <span>{{ item.aduroArrivalTime }}</span>
                    </template>
                  </div>
                </div>
                <div class="add-on-wrapper">
                  <div class="add-on-item">
                    <div class="text">
                      <input type="checkbox" v-model="item.isOnlineScheduler" id="is-online-scheduler"
                             :disabled="!editable || isLocked || isUpdating"/>
                      <label for="is-online-scheduler">Toggle</label>
                    </div>
                    <div class="text title" :class="{active: item.isOnlineScheduler}">Online Scheduler</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="text-contact grey-3">
                <div class="label">Name</div>
                <div class="contactName">{{ item.contactName }}</div>
              </div>
              <div class="text-contact grey-3">
                <div class="label">Email</div>
                <div><input v-model="item.email" @blur="unlockEvent(); checkEmailValid();"
                            class="phoneAndEmail"
                            v-on:focus="lockEvent()"
                            placeholder="E.g. hannah_welch@gmail.com" :disabled="!editable || isLocked || isUpdating"/>
                </div>
              </div>
              <div class="text-contact grey-3">
                <div class="lable">Phone</div>
                <the-mask mask="(###) ###-####"
                          v-model="item.phone"
                          v-on:onTheMaskBlur="unlockEvent(); prefDateBlur(eventFields.phone)"
                          class="phoneAndEmail"
                          @focus.native="lockEvent()"
                          :masked="isTrue"
                          placeholder="(123) 123-1234"
                          :disabled="!editable || isLocked || isUpdating"></the-mask>
              </div>
            </div>
            <div class="col-sm-2">
              <div class="event-add-on">
                <div class="add-on-item-wrapper">
                  <div v-for="(itemAddOn, index) in item.additionalServices" :key="index" class="add-on-item"
                       v-if="itemAddOn.isShow">
                    <span class="text"
                          :class="disableAdditionalServices(itemAddOn.key) ? 'greyOut' : null" v-b-tooltip.hover.bottom :title="itemAddOn.text">{{ itemAddOn.text
                      }}</span>
                    <input type="checkbox" :id="itemAddOn.key + '_' +item.id + '_' + showOnModal"
                           v-model="itemAddOn.value" @change="checkboxToggle(itemAddOn.key, itemAddOn.value)"
                           :disabled="disableAdditionalServices(itemAddOn.key)"
                           :class="disableAdditionalServices(itemAddOn.key) ? 'greyOut' : null"/><label
                    :for="itemAddOn.key + '_' +item.id + '_' + showOnModal">Toggle</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- BUTTON FUNCTION GROUP -->
          <div class="func-group">
            <DataTableGroupBtn :isLocked="isLocked" :showOnModal="showOnModal" :editEventAdmin="editEventAdmin"
                               :viewMode="viewMode" :eventStatus="eventStatus" :item="item"
                               :isSuggestChanges="suggestChanges"></DataTableGroupBtn>
          </div>
          <!-- END: BUTTON FUNCTION GROUP -->
        </div>
      </div>
      <div class="related-event">
        <RelatedEvent v-if="showRelatedEvent" :item='item'></RelatedEvent>
      </div>
    </b-collapse>
  </div>
</template>

<script>
  import 'vue-awesome/icons/exclamation-circle';
  import 'vue-awesome/icons/arrow-circle-o-right';
  import 'vue-awesome/icons/chevron-right';
  import 'vue-awesome/icons/chevron-down';
  import 'vue-awesome/icons/floppy-o';
  import 'vue-awesome/icons/trash-o';
  import 'vue-awesome/icons/repeat';
  import 'vue-awesome/icons/exchange';
  import 'vue-awesome/icons/angle-right';
  import 'vue-awesome/icons/refresh';
  import 'vue-awesome/icons/question-circle';
  import 'vue-awesome/icons/files-o';
  import LoadScript from 'vue-plugin-load-script';

  import Multiselect from 'vue-multiselect';
  import Icon from 'vue-awesome/components/Icon';
  import Vue from 'vue';
  import axios from 'axios';
  import VueAxios from 'vue-axios';
  import constants from '../../_consts';
  import moment from 'moment';
  import {mapActions, mapGetters} from 'vuex';
  import DataTableGroupBtn from './DataTableGroupBtn';
  import RowStatus from './RowStatus';
  import RelatedEvent from './RelatedEvent';
  import {TheMask} from '../utils/vue-the-mask';
  import CalendarDatePickerDataTable from '../commons/CalendarDatePickerDataTable';
  import { abbrState } from '../../utils/stateToAbbr.js';

  import VueGoogleAutocomplete from 'vue-google-autocomplete';
  import {trim, isEmpty} from 'lodash';
  import dropdown from 'vue-dropdowns';
  import validator from '@/utils/validator.js';

  Vue.use(VueAxios, axios);
  Vue.use(LoadScript);

  export default {
    name: 'dataTableRowEditMode',
    components: {
      Icon,
      Multiselect,
      DataTableGroupBtn,
      RowStatus,
      RelatedEvent,
      TheMask,
      VueGoogleAutocomplete,
      CalendarDatePickerDataTable,
      dropdown
    },
    props: {
      id: {
        type: Number,
        default: 0
      },
      index: {
        type: Number,
        default: 0
      },
      eventStatus: {
        type: String
      },
      item: {
        type: Object,
        default: {}
      },
      viewMode: {
        type: String,
        default: 'Client'
      },
      editable: {
        type: Boolean,
        default: false
      },
      showOnModal: {
        type: Boolean,
        default: false
      },
      editEventAdmin: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        showCollapse: false,
        focusedColumn: '',
        listOptionPrefMonth: constants.listOptionPrefMonth,
        isSuggestChanges: false,
        iconNames: constants.iconNames,
        listEventStatus: constants.eventStatus,
        viewModes: constants.dataTableViewModes,
        requiredPrefMonth: false,
        requiredPrefDate: false,
        requiredProjPart: false,
        requiredAddress: false,
        requiredLocation: false,
        requiredStartTime: false,
        requiredDuration: false,
        requiredContactName: false,
        requiredPhone: false,
        requiredEmail: false,
        listContact: [],
        instructions: constants.instructions,
        eventFields: constants.fields.event,
        isTrue: true,
        messageErrors: constants.messageErrors,
        isLocked: false,
        isInSetPlace: false,
        disableDuration: false,
        showDateTimePicker: false,
        listTime: constants.listTime,
        selectedTime: {},
        selectedAddress: {},
        arrivalTime: {name: this.item.aduroArrivalTime},
        isAddressError: false
      };
    },
    computed: {
      selectedDate () {
        return moment(this.item.prefDate, 'MM/DD/YYYY');
      },
      newPrefDate () {
        let time = moment(this.item.prefDate, 'MM/DD/YYYY');
        let str = time.format('DD') + '/' + time.format('YYYY');
        this.item.newPrefDate = str;
        return str;
      },
      expandId () {
        return this.getExpandId;
      },
      showRelatedEvent () {
        return this.showRelatedEvents;
      },
      accordionId () {
        return `accordion-${this.item.index}`;
      },
      eventName () {
        if (this.item.eventName === undefined || this.item.eventName === '') {
          this.item.eventName = 'New Event';
        }
        return this.item.eventName;
      },
      enableNoteForProjPart () {
        return (this.item.duration === 4 || this.item.duration === 8);
      },
      enableNoteForEventDuration () {
        return (this.item.duration === 4 || this.item.duration === 8);
      },
      calculateTimeEnd () {
        if (!this.item.startTime) {
          return 'End time';
        }
        let listStr = this.item.startTime.toString().split(/[\s:]/);
        if (listStr.length === 3) {
          let duration = Number(this.item.duration);
          let minute = Number(listStr[1]);
          let hour = Number(listStr[0]);
          let hourType = listStr[2];
          hour = hourType === 'AM' && (hour === 12 || hour === 0) ? 0 : hour;
          hour = hourType === 'PM' && (hour === 12 || hour === 0) ? 0 : hour;
          hour = hourType === 'AM' ? hour : hour + 12;
          hour += duration;
          minute = hour % 1 === 0.5 ? minute + 30 : minute;
          hour = hour % 1 === 0.5 ? hour - 0.5 : hour;
          hour = minute > 59 ? hour + 1 : hour;
          minute = minute > 59 ? minute % 60 : minute;
          if (hour >= 24) {
            hourType = 'AM';
            hour = hour % 12;
          } else {
            if (hour > 11) {
              // hour %= 12;
              /* We want to display 12 instead of 0 */
              hour = hour === 12 ? 12 : hour % 12;
              hourType = 'PM';
            } else {
              hourType = 'AM'
            }
          }
          let prefix = minute < 10 ? '0' : '';
          this.item.endTime = hour + ':' + prefix + minute + ' ' + hourType;
        } else {
          this.item.endTime = '';
        }
        return this.item.endTime;
      },
      enableIconProjPart () {
        return (this.item.projPart > 0) && (this.item.projPart <= 32 || this.item.projPart > 200);
      },
      enableIconDuration () {
        return this.item.duration < 4 || this.item.duration > 8;
      },
      disableIconContact () {
        // return this.item.contactName === '';
        return !(this.item.email !== '' && this.item.phone !== '' && this.item.contactName !== '');
      },
      calculateShippingAddress () {
        if (this.item.shippingAddress === '') {
          this.item.shippingAddress = this.item.fullAddress;
        }
        return this.item.shippingAddress;
      },
      viewRelatedEvent () {
        return this.showRelatedEvents;
      },
      projectPart () {
        return this.item.projPart;
      },
      isCreateByEM () { // event create by && view by
        let a = localStorage.getItem(constants.LOCAL_STORE.role) === constants.USER_ROLE.eventManager;
        let b = this.item.createdBy && this.item.createdBy.toString() === localStorage.getItem(constants.LOCAL_STORE.userId).toString();
        return a && b;
      },
      isEM () {
        let role = localStorage.getItem(constants.LOCAL_STORE.role);
        return role === constants.USER_ROLE.eventManager || role === constants.USER_ROLE.admin;
      },
      columnWidth () {
        return this.getColumnWidth;
      },
      onSiteContacts () {
        return this.listOnSiteContact;
      },
      suggestChanges () {
        return (this.isSuggestChanges && this.item.isSuggestChanges) || false;
      },
      calculateDisableDuration () {
        this.disableDuration = this.item.disableDuration;
      },
      isReadOnly () {
        return localStorage.getItem(constants.LOCAL_STORE.readOnly) === 'true';
      },
      isUsedBingMap () {
        return localStorage.getItem(constants.LOCAL_STORE.isBingMap) === 'true';
      },
      ...mapGetters({
        getExpandId: 'GETTERS_GET_EXPAND_ID',
        showRelatedEvents: 'GETTERS_SHOW_RELATED_EVENT',
        getColumnWidth: 'GETTERS_GET_COLUMN_WIDTH',
        listOnSiteContact: 'GETTERS_LIST_ON_SITE_CONTACT',
        messageError: 'GETTERS_MESSAGE_ERROR',
        googleMapApiKey: 'GETTERS_GOOGLE_API_KEY',
        getLockIds: 'GETTERS_GET_LOCK_IDS',
        getErrorCodes: 'GETTERS_ERROR_CODES',
        currentClient: 'GETTER_GET_SELECTED_CLIENT',
        isLoading: 'GETTERS_IS_LOADING',
        isUpdating: 'GETTERS_IS_UPDATING'
      })
    },
    methods: {
      checkEmailValid () {
        return validator.isValidEmail(this.item.email);
      },
      disableAdditionalServices (key) {
        if (this.eventStatus === constants.eventStatus.drafts || this.showOnModal) {
          if (key === constants.listAdditionalServicesKey.cotinine) {
            return this.item.additionalServices[7].isShow && this.item.additionalServices[7].value; // check order in constants
          }
          if (key === constants.listAdditionalServicesKey.tobaccoSelfAttestation) {
            return this.item.additionalServices[3].isShow && this.item.additionalServices[3].value; // check order in constants
          }
          if (key === constants.listAdditionalServicesKey.smallSiteConcierge) {
            return this.item.additionalServices[6].isShow && !this.item.additionalServices[6].value; // check order in constants
          }
        }
        return !(this.eventStatus === constants.eventStatus.drafts || this.showOnModal);
      },
      setStartTime (payload) {
        this.item.startTime = payload.name;
        let listStr = this.item.startTime.toString().split(/[\s:]/);
        let minute = listStr[1];
        let hour = Number(listStr[0]);
        let hourType = listStr[2];
        let arrivalTime = 0;

        if (hour > 0) {
          if (hour === 12 && hourType === 'PM') {
            hourType = 'AM';
          }
          arrivalTime = hour - 1;
        }

        let time = { name: arrivalTime + ':' + minute + ' ' + hourType };
        this.setAduroArrivalTime(time);
        this.updateEvent(this.item);
      },
      setAduroArrivalTime (payload) {
        this.item.aduroArrivalTime = payload.name;
        this.$refs['arrivalTime'].selectedOption = payload;
      },
      selectDate (dateStr) {
        this.item.prefDate = dateStr;
        this.updateEvent(this.item);
        // hide date picker after selected
        if (this.showDateTimePicker) {
          this.toggleShowDateTimePicker();
        }
      },
      setSelected (dateStr) {
      },
      setExpandId () {
        if (this.item.id === 0) {
          return;
        }
        this.setExpandIdInState({id: this.item.id, isExpand: false});
        if (this.showRelatedEvent) {
          this.restoreListEvent();
          this.setShowRelatedEvents(false);
        }
        this.showDateTimePicker = this.showDateTimePicker && (this.item.id === this.expandId);
      },
      toggleShowDateTimePicker () {
        this.showDateTimePicker = !this.showDateTimePicker;
        if (!this.item.showCollapse) {
          this.setExpandId();
          this.item.showCollapse = (this.item.id === this.expandId);
        }
      },
      toggleShowTimePicker () {
        if (!this.item.showCollapse) {
          this.setExpandId();
          this.item.showCollapse = (this.item.id === this.expandId);
        }
      },
      duplicateEventClick () {
        if (this.isLocked) {
          return;
        }
        this.duplicateEvent({item: this.item});
      },
      deleteEventClick () {
        if (this.isLocked) {
          return;
        }
        // implement code
        let modalData = {
          action: constants.modalAction.deleteEvent,
          data: this.item
        };
        this.$modal.show('eventModal', modalData);
      },
      submitEventClick () {
        this.$modal.show('DraftEventModal');
        // if (this.isReadOnly) {
        //   let modalData = {
        //     action: constants.modalAction.readOnly,
        //     data: null
        //   };
        //   this.$modal.show('eventModal', modalData);
        //   return;
        // }
        // if (this.isLocked) {
        //   return;
        // }
        // let result = this.validateModal();
        // let validDate = this.checkDateValid();

        // if (validDate) {
        //   let modalData = {
        //     action: constants.modalAction.eventPrefDateInvalid,
        //     data: null
        //   };
        //   this.$modal.show('eventModal', modalData);
        //   return;
        // }

        // let emailValid = this.checkEmailValid();
        // if (!emailValid) {
        //   let modalData = {
        //     action: constants.modalAction.emailIsNotValid,
        //     data: null
        //   };
        //   this.$modal.show('eventModal', modalData);
        //   return;
        // }

        // if (this.enableIconDuration === true && this.isEM === false) {
        //   this.item.showCollapse = !this.item.showCollapse;
        //   this.setExpandIdInState({id: this.item.id, isExpand: false});
        //   let modalData = {
        //     action: constants.modalAction.eventDurationRestricted,
        //     data: null
        //   };
        //   this.$modal.show('eventModal', modalData);
        //   return;
        // }
        // if (!result) {
        //   let modalData = {
        //     action: constants.modalAction.submitEvent,
        //     data: this.item
        //   };
        //   this.$modal.show('eventModal', modalData);
        // } else {
        //   let modalData = {
        //     action: constants.modalAction.someFieldsBlank,
        //     data: null
        //   };
        //   this.$modal.show('eventModal', modalData);
        // }
      },
      lockEvent () {
        this.$emit('lockEvent', this.item.id, true);
      },
      unlockEvent () {
        this.$emit('unlockEvent', this.item.id, false);
      },
      modifyShippingAddress (data, place) {
        this.item.shippingAddress = place.formatted_address;
      },
      setFocus (column) {
        this.focusedColumn = column;
      },
      unsetFocus (column) {
        this.focusedColumn = '';
        // save
        if (this.item[column] === '') {
          return;
        }
        this.saveEvent();
      },
      inputFullAddressFocus () {
        this.focusFullAddress = true;
      },
      getValue (valObj) {
        let role = localStorage.getItem(constants.LOCAL_STORE.role);
        if (role === constants.USER_ROLE.eventManager || role === constants.USER_ROLE.admin) {
          this.item.fullAddress = valObj;
          if (!this.item.shippingAddress) {
            this.item.shippingAddress = this.item.fullAddress;
          }
          if (!this.isInSetPlace) {
            this.saveEvent();
          }
        }
      },
      setPlace (data, place) {
        this.isInSetPlace = true;
        this.setPlaceShippingAddress(place, true);
        this.item.fullAddress = place.formatted_address;
        let res = place && place.formatted_address.split(',');
        let resAdr = '';
        if (res.length > 3) {
          let temp = trim(res[res.length - 2]).split(' ');
          resAdr = temp[0] + '-' + res[res.length - 3];
        }
        this.item.eventName = resAdr;
        // save address components
        let addressComponents = place.address_components;
        this.item.state = null;
        this.item.city = null;
        this.item.zipCode = null;
        for (let i = 0; i < addressComponents.length; i++) {
          let component = addressComponents[i];
          if (component.types.indexOf('sublocality_level_1') >= 0 || component.types.indexOf('sublocality') >= 0 || component.types.indexOf('locality') >= 0) {
            this.item.city = component.long_name;
          }
          if (component.types[0] === 'administrative_area_level_1') {
            this.item.state = component.short_name;
          }
          if (component.types[0] === 'postal_code') {
            this.item.zipCode = component.short_name;
          }
        }

        this.item.latitude = place.geometry.location.lat() || 0;
        this.item.longitude = place.geometry.location.lng() || 0;

        // get time zone
        let apiStr = 'https://maps.googleapis.com/maps/api/timezone/json';
        let req = Vue.axios.create();
        req.get(apiStr, {
          params: {
            location: `${place.geometry.location.lat()},${place.geometry.location.lng()}`,
            timestamp: `${Math.round((new Date().getTime()) / 1000)}`,
            key: this.googleMapApiKey === '' ? localStorage.getItem(constants.LOCAL_STORE.googleAPIKey) : this.googleMapApiKey
          }
        }).then((response) => {
          if (response.data) {
            let data = response.data;
            this.item.timeZone = this.getTimeZone(data.timeZoneName);
            this.item.timeZoneId = data.timeZoneId;
            this.saveEvent();
          } else {
            Vue.prototype.$toastr('error', 'Error calling Google Maps API', '');
          }
          this.isInSetPlace = false;
        });
      },
      getTimeZone (tzString) {
        if (tzString.length === 0) {
          return '';
        }
        let str = '';
        let index = 0;
        while (index >= 0) {
          str += tzString.substr(0, 1);
          index = tzString.indexOf(' ');
          tzString = tzString.substring(index + 1);
        }
        return str;
      },
      setPlaceShippingAddress (place, isAddress) {
        let fieldName = this.eventFields.shippingAddress;
        let userFilled = this.item.userManualFilled;
        if (isAddress !== true) {
          this.item.userManualFilled = userFilled === '' ? fieldName : userFilled.concat(',' + fieldName);
          this.item.shippingAddress = place.formatted_address;
          this.saveEvent();
        } else {
          if (userFilled.indexOf(fieldName) === -1) {
            this.item.shippingAddress = place.formatted_address;
          }
        }
      },
      isAddressReadyToUpdate () {
        return !isEmpty(this.item.latitude && this.item.longitude && this.item.city && this.item.state && this.item.zipCode && this.item.timeZoneId);
      },
      addressErrorMessage () {
        const generateAddress = [
          isEmpty(this.item.latitude) ? 'Street Name' : '',
          isEmpty(this.item.longitude) ? 'Number' : '',
          isEmpty(this.item.city) ? 'City' : '',
          isEmpty(this.item.state) ? 'State' : '',
          isEmpty(this.item.zipCode) ? 'ZipCode' : '',
          isEmpty(this.item.timeZoneId) ? 'TimeZoneId' : ''
        ];
        const message = generateAddress.filter(item => item !== '').join(', ');
        return `Please include ${message}`;
      },
      saveEvent (obj) {
        if (this.isLocked) {
          return;
        }
        this.item.index = this.index;
        // if (this.item.duration === null || this.item.duration === '' || this.item.duration === undefined) {
        //   this.calculateDuration();
        // }
        if (this.eventStatus === constants.eventStatus.drafts) {
          this.isAddressError = false;
          if (this.isAddressReadyToUpdate()) {
            this.updateEvent(this.item);
          } else {
            this.isAddressError = true;
          }
        }
        if (this.eventStatus === constants.eventStatus.review || this.eventStatus === constants.eventStatus.submitted) {
          this.isSuggestChanges = true;
          this.item.isSuggestChanges = true;
        }
      },
      rowActionMiddleClick () {
        let role = localStorage.getItem(constants.LOCAL_STORE.role);
        if (this.eventStatus.toLowerCase() === constants.eventStatus.submitted.toLowerCase() && role === constants.USER_ROLE.eventManager) {
          this.setItemRelated(this.item);
          this.setExpandIdInState({id: this.item.id, isExpand: false});
        }
      },
      btnChangeOrderClick () {
        let modalData = {
          action: constants.modalAction.changeOrder,
          data: this.item
        };
        this.$modal.show('eventModal', modalData);
      },
      restoreEvent () {
        let prefDate = this.item.prefDate.split('/');
        let year = Number(prefDate.pop()) + 1;
        let newItem = Object.assign({}, this.item);
        newItem.prefDate = prefDate[0] + '/' + year;
        newItem.status = constants.eventStatus.drafts.toUpperCase();
        this.duplicateEvent({item: newItem});
      },
      calculateDuration () {
        let projPart = this.item.projPart;
        let services = this.findAdditionalSercives(constants.listAdditionalServicesKey.smallSiteModel);
        if (services !== null && services.value === true) {
          if (projPart < 9) {
            this.item.duration = 4;
          }
          if (projPart > 8 && projPart < 17) {
            this.item.duration = 5;
          }
          if (projPart > 16 && projPart < 25) {
            this.item.duration = 6;
          }
          if (projPart > 24 && projPart < 29) {
            this.item.duration = 7;
          }
          if (projPart > 28) {
            this.item.duration = 8;
          }
        } else {
          let userFilled = this.item.userManualFilled;
          if (userFilled.indexOf(this.eventFields.duration) === -1) {
            if (projPart > 0 && projPart <= 32) {
              this.item.duration = 4;
            }
            if (projPart > 32 && projPart < 100) {
              this.item.duration = 4;
            }
            if (projPart >= 100 && projPart <= 140) {
              this.item.duration = 5;
            }
            if (projPart > 140 && projPart < 170) {
              this.item.duration = 6;
            }
            if (projPart >= 170 && projPart < 200) {
              this.item.duration = 7;
            }
            if (projPart >= 200) {
              this.item.duration = 8;
            }
          }
        }
      },
      findAdditionalSercives (key) {
        let result = null;
        this.item.additionalServices.forEach(element => {
          if (element.key === key) {
            result = element;
          }
        });
        return result;
      },
      disableToggleSmallSiteModal () {
        let item = this.item;
        item.additionalServices.forEach((addOn, index) => {
          if (addOn.key === constants.listAdditionalServicesKey.smallSiteModel || addOn.key === constants.listAdditionalServicesKey.smallSiteConcierge) {
            if (parseInt(item.projPart) < 34) {
              this.item.additionalServices[index].isShow = true;
              this.item.additionalServices[index].value = false;
              this.item.disableDuration = true;
              let obj = {
                eventId: this.item.id,
                key: this.item.additionalServices[index].key,
                isAdd: this.item.additionalServices[index].value,
                index: this.item.index
              };
              this.updateEventAddOns(obj); // save addon to database when changing participant
            } else {
              this.item.additionalServices[index].isShow = false;
              this.item.additionalServices[index].value = false;
              this.item.disableDuration = false;
              let obj = {
                eventId: this.item.id,
                key: this.item.additionalServices[index].key,
                isAdd: this.item.additionalServices[index].value,
                index: this.item.index
              };
              this.updateEventAddOns(obj) // save addon to database when changing participant
            }
          }
        });
      },
      changeTimeStart () {
        if (!this.errors.has('start-time')) {
          this.item.startTime = this.item.timeStartModel;
          this.saveEvent();
        }
      },
      checkDateValid () {
        if (this.item.prefDate === null || this.item.prefDate.length !== 10) {
          return true;
        }
        let role = localStorage.getItem(constants.LOCAL_STORE.role);
        let isEMOrAdmin = role !== constants.USER_ROLE.eventManager && role !== constants.USER_ROLE.admin;
        let prefDate = moment(this.item.prefDate, constants.dateTimeFotmat.usFormat);
        return (prefDate.format() === 'Invalid Date' || moment().add(90, 'days').isSameOrAfter(prefDate)) && isEMOrAdmin;
      },
      validateModal () {
        // this.requiredPrefMonth = this.item.prefMonth === '' || this.item.prefMonth === null || this.item.prefMonth === undefined;
        this.requiredPrefDate = this.item.prefDate === '' || this.item.prefDate === null || this.item.prefDate === undefined;
        this.requiredProjPart = this.item.projPart <= 0 || this.item.projPart === '' || this.item.projPart === null || this.item.projPart === undefined;
        this.requiredAddress = this.item.fullAddress === '' || this.item.fullAddress === null || this.item.fullAddress === undefined;
        this.requiredStartTime = this.item.startTime === '' || this.item.startTime === null || this.item.startTime === undefined;
        this.requiredContactName = this.item.contactName === '' || this.item.contactName === null || this.item.contactName === undefined;
        this.requiredLocation = this.item.eventLocation === '' || this.item.eventLocation === null || this.item.eventLocation === undefined;
        this.requiredDuration = this.item.duration < 1 || this.item.duration === '' || this.item.duration === null || this.item.duration === undefined;
        this.requiredPhone = this.item.phone === '' || this.item.phone === null || this.item.phone === undefined;
        this.requiredEmail = this.item.email === '' || this.item.email === null || this.item.email === undefined;
        return this.requiredPrefDate || this.requiredProjPart || this.requiredAddress || this.requiredStartTime || this.requiredContactName || this.requiredLocation || this.requiredDuration || this.requiredPhone || this.requiredEmail;
      },
      selectOnSiteContact (contact) {
        if (contact) {
          this.item.contactName = contact.contactName;
          this.item.phone = contact.contactPhone;
          this.item.email = contact.contactEmail;
        }
      },
      searchContact (keyword) {
        this.getListOnSiteContact(keyword.toLowerCase());
        let name = keyword || this.item.contactName;
        this.item.contact = {
          contactName: name,
          contactPhone: this.item.phone,
          contactEmail: this.item.email
        }
      },
      closeOnsiteContact (value, id) {
        if (this.isLocked) {
          return;
        }
        if (!value) {
          value = {
            contactName: this.item.contactName,
            contactPhone: this.item.phone,
            contactEmail: this.item.email
          };
          this.item.contact = value;
          return;
        }
        this.item.contactName = value.contactName;
        this.unlockEvent();
        this.updateEvent(this.item);
      },
      durationBlur (fieldName) {
        if (this.item.durationBackup === null || this.item.durationBackup === undefined || this.item.durationBackup === this.item.duration) {
          return;
        }
        let duration = parseFloat(this.item.duration);
        if (isNaN(this.item.duration) || duration % 0.5 !== 0) {
          Vue.prototype.$toastr('error', 'Please enter duration in half hour increments', '');
          return;
        }
        this.item.duration = duration === 0.5 ? '0.5' : this.item.duration;
        let userFilled = this.item.userManualFilled;
        if (userFilled.indexOf(fieldName) === -1 && this.item.durationBackup !== this.item.duration) {
          this.item.userManualFilled = userFilled === '' ? fieldName : userFilled.concat(',' + fieldName);
        }
        this.saveEvent();
      },
      prefDateBlur (field) {
        if (field === this.eventFields.prefDate) {
          let validDate = this.checkDateValid();
          if (validDate) {
            Vue.prototype.$toastr('error', 'Please enter valid event date!', '');
            return;
          }
        }
        if (field === this.eventFields.timeStartModel) {
          let listStr = this.item.timeStartModel.toString().split(/[\s:]/);
          if (listStr[2] !== 'AM' && listStr[2] !== 'PM') { // => error format
            Vue.prototype.$toastr('error', 'Please enter valid event time!', '');
            this.item.startTime = '';
            return;
          }
          this.item.startTime = this.item.timeStartModel;
        }
        this.saveEvent();
      },
      eventNameBlur (fieldName) {
        if (this.item.eventName === null || this.item.eventName === '' || this.item.eventName === this.item.eventNameBackup) {
          this.item.eventName = this.item.eventNameBackup;
          return;
        }
        let userFilled = this.item.userManualFilled;
        if (userFilled.indexOf(fieldName) === -1) {
          this.item.userManualFilled = userFilled === '' ? fieldName : userFilled.concat(',' + fieldName);
        }
        this.updateEvent(this.item);
      },
      checkboxToggle (key, value) {
        let obj = {
          eventId: this.item.id,
          key: key,
          isAdd: value,
          index: this.item.index
        };
        if (key === constants.listAdditionalServicesKey.paperScheduler) {
          this.item.isOnlineScheduler = !value;
        }
        if (this.item.id !== 0 && !this.showOnModal) {
          this.updateEventAddOns(obj).then(() => {
            this.$toastr('info', 'Update event successful', '');
            if (key === constants.listAdditionalServicesKey.smallSiteModel) {
              this.calculateDuration();
              this.updateEvent(this.item);
            }
            if (key === constants.listAdditionalServicesKey.cotinine) {
              this.updateEventAddOns({
                eventId: this.item.id,
                key: constants.listAdditionalServicesKey.tobaccoSelfAttestation,
                isAdd: false,
                index: this.item.index
              }).then(() => {
                this.triggerSavingAddonForEvent();
              });
            }
            if (key === constants.listAdditionalServicesKey.tobaccoSelfAttestation) {
              this.updateEventAddOns({
                eventId: this.item.id,
                key: constants.listAdditionalServicesKey.cotinine,
                isAdd: false,
                index: this.item.index
              }).then(() => {
                this.triggerSavingAddonForEvent();
              });
            }
          });
        } else {
          let addOns = '';
          this.item.additionalServices.forEach((addOn) => {
            if ((addOn.key === key && value) || (addOn.key !== key && addOn.value)) {
              if (addOns !== '') addOns += ',';
              addOns += addOn.key;
            }
          });

          if (key === constants.listAdditionalServicesKey.smallSiteModel && !value) {
            // turn off the smallSiteConcierge when Small site model is off
            if (addOns.indexOf('smallSiteConcierge') >= 0) {
              addOns = addOns.replace('smallSiteConcierge', '');
              this.disableToggleSmallSiteConcierge(this.item);
            }
          }
          this.item.addOns = addOns;
          this.updateEvent(this.item);
        }
      },
      disableToggleSmallSiteConcierge (item) {
        item.additionalServices.forEach((addOn, index) => {
          if (addOn.key === constants.listAdditionalServicesKey.smallSiteConcierge) {
            this.item.additionalServices[index].value = false;
          }
        });
      },
      openAddonsModal () {
        this.$modal.show('addonsModal');
      },
      triggerSavingAddonForEvent () {
        this.item.customEventNote += '.';
        this.item.customEventNote = this.item.customEventNote.slice(0, -1);
      },
      // START BING SECTION
      selectedAddressFromBing (obj) {
        let addressDetail = obj.address;
        let location = obj.location;
        this.item.fullAddress = addressDetail.formattedAddress;
        if (this.item.shippingAddress === '') {
          this.item.shippingAddress = this.item.fullAddress;
        }
        if (!addressDetail.adminDistrict || !addressDetail.locality || !addressDetail.postalCode) {
          this.getFullAddressWithNoAdminAndPostalCode(addressDetail.formattedAddress).then(address => {
            if (address) {
              addressDetail = address;
            } else {
              this.$toast.success('Please enter a complete address including city and state or zip code', '', {
                ...this.$toastOpt.optError
              });
            }
            this.item.state = addressDetail.adminDistrict;
            this.getAddressInfoForEvent(addressDetail, location)
          });
          return;
        }
        this.item.state = abbrState(addressDetail.adminDistrict, 'abbr');
        this.getAddressInfoForEvent(addressDetail, location)
      },
      getAddressInfoForEvent (addressDetail, location) {
        this.item.city = addressDetail.locality ? addressDetail.locality : '';
        this.item.eventName = this.item.state + '- ' + this.item.city;
        // get time zone
        this.item.zipCode = addressDetail.postalCode;
        this.item.latitude = (location && location.latitude) ? location.latitude : 0;
        this.item.longitude = (location && location.longitude) ? location.longitude : 0;
        let apiStr;
        if (location && location.latitude && location.longitude) {
          apiStr = 'https://dev.virtualearth.net/REST/v1/TimeZone/' + location.latitude + ',' + location.longitude;
        } else {
          apiStr = 'https://dev.virtualearth.net/REST/v1/TimeZone/query=' + this.item.city;
        }
        let req = Vue.axios.create();
        req.get(apiStr, {
          params: {
            key: process.env.BING_MAP_KEY // this.googleMapApiKey === '' ? localStorage.getItem(constants.LOCAL_STORE.googleAPIKey) : this.googleMapApiKey
          }
        }).then((response) => {
          if (response.data && response.data.resourceSets[0].resources[0]) {
            let data = response.data.resourceSets[0].resources[0].timeZone;
            this.item.timeZone = data.abbreviation;
            this.item.timeZoneId = data.ianaTimeZoneId;
            this.saveEvent();
          } else {
            Vue.prototype.$toastr('error', 'Error calling Bing Maps API', '');
          }
          this.isInSetPlace = false;
        });
      },
      selectedShippingAddressFromBing (obj) {
        let addressDetail = obj.address;
        this.item.shippingAddress = addressDetail.formattedAddress;
      },
      onLoadBingSuggest () {
        console.log('load bing suggest');
        let options = { maxResults: 5 };
        (new window.Microsoft.Maps.AutosuggestManager(options)).attachAutosuggest('#searchBox-' + this.showOnModal + '-' + this.item.index, '#searchBoxContainer-' + this.item.index, this.selectedAddressFromBing);
        (new window.Microsoft.Maps.AutosuggestManager(options)).attachAutosuggest('#searchBoxForShippingAddress-' + this.showOnModal + '-' + this.item.index, '#searchBoxForShippingAddressContainer-' + this.item.index, this.selectedShippingAddressFromBing);
      },
      onErrorBingSuggest (message) {
        console.log('printoutPanel', message);
      },
      getFullAddressWithNoAdminAndPostalCode (address) {
        return new Promise(resolve => {
          // let vm = this;
          let map = new window.Microsoft.Maps.Map(document.getElementById('myMap'), {
            credentials: process.env.BING_MAP_KEY
          });
          let searchManager = new window.Microsoft.Maps.Search.SearchManager(map);
          let requestOptions = {
            where: address,
            callback: function (answer, userData) {
              if (answer && answer.results.length > 0) {
                resolve(answer.results[0].address);
                return;
              }
              resolve(null)
            },
            errorCallback: function (e) {
              console.log('geocodeError=', e);
            }
          };
          searchManager.geocode(requestOptions);
        })
      },
      // END BING SECTION
      ...mapActions({
        updateEvent: 'ACTION_UPDATE_EVENT',
        duplicateEvent: 'ACTION_DUPLICATE_EVENT',
        setExpandIdInState: 'ACTION_SET_EXPAND_ID',
        setItemRelated: 'ACTION_SET_ITEM_RELATED',
        restoreListEvent: 'ACTION_RESTORE_LIST_EVENT',
        setShowRelatedEvents: 'ACTION_SET_SHOW_RELATED_EVENT',
        getListOnSiteContact: 'ACTION_GET_LIST_ON_SITE_CONTACT',
        updateEventAddOns: 'ACTION_UPDATE_EVENT_ADD_ON'
      })
    },
    mounted () {
      if (this.isUsedBingMap) {
        if (window.Microsoft.Maps.AutosuggestManager == null) {
          window.Microsoft.Maps.loadModule('Microsoft.Maps.AutoSuggest', {
            callback: this.onLoadBingSuggest,
            errorCallback: this.onErrorBingSuggest
          });
        } else {
          this.onLoadBingSuggest();
        }
      }
      this.item.index = this.index;
      if (this.showOnModal === true) {
        this.item.showCollapse = this.showOnModal;
      }
    },
    created () {
      // computed locked
      let index = this.getLockIds.eventIds.indexOf(this.item.id.toString());
      this.isLocked = index !== -1 ? this.getLockIds.userIds[index] !== (localStorage.getItem(constants.LOCAL_STORE.userId)) : false;
    },
    watch: {
      viewRelatedEvent: function () {
        this.item.showCollapse = this.viewRelatedEvent;
      },
      projectPart: function () {
        this.disableToggleSmallSiteModal();
        this.calculateDuration();
      },
      getExpandId: function () {
        if (this.getExpandId === -1) {
          this.item.showCollapse = false;
        }
        if (this.item.id !== this.getExpandId) {
          this.showDateTimePicker = false;
        }
      },
      messageError: function () {
        if (this.messageError === this.messageErrors.notUniqueName) {
          let modalData = {
            action: constants.modalAction.eventNameNotUnique,
            data: null
          };
          this.$modal.show('eventModal', modalData);
        }
      },
      listOnSiteContact: function () {
        let element = this.$el.querySelector('.col-contact .multiselect__content-wrapper');
        if (this.listOnSiteContact && this.listOnSiteContact.length > 0) {
          element.style.border = '1px solid #e6e6e6';
          element.style.padding = '0 0 7px 0';
        } else {
          element.style.border = 'none';
          element.style.padding = '0 0 0px 0';
        }
      },
      getLockIds: {
        handler: function () {
          let index = this.getLockIds.eventIds.indexOf(this.item.id.toString());
          this.isLocked = index !== -1 ? this.getLockIds.userIds[index] !== (localStorage.getItem(constants.LOCAL_STORE.userId)) : false;
        },
        deep: true
      },
      item: {
        handler: function () {
          this.disableDuration = this.item.disableDuration;
        },
        deep: true
      },
      'item.additionalComments': {
        handler: function (newValue, oldValue) {
          if (newValue.length > 1000) {
            this.item.additionalComments = oldValue;
          }
        }
      }
    }
  };
</script>

<style lang="less">
  @import '../../styles/variables.less';
  @import '../../styles/aduro/index.less';
  .greyOut {
    color: @grey-11;
  }

  .multiselect__content > .multiselect__element:first-child {
    margin-top: 7px;
  }

  .event-name-no-edit {
    // margin-left: 4px;
  }

  .icon-draft {
    display: inline-block;
    margin-left: -4px;
    width: 24px;
    height: 24px;
    color: @grey-1;
    background-color: @grey-1;
    -webkit-mask: url('../../../static/img/event-drafts.svg') no-repeat center;
    mask: url('../../../static/img/event-drafts.svg') no-repeat center;
    background: url('../../../static/img/event-drafts-grey.svg');
  }

  .icon-submitted {
    display: inline-block;
    margin-left: -2px;
    width: 24px;
    height: 24px;
    color: @grey-1;
    background-color: @grey-1;
    -webkit-mask: url('../../../static/img/event-submitted.svg') no-repeat center;
    mask: url('../../../static/img/event-submitted.svg') no-repeat center;
    background: url('../../../static/img/event-submitted-grey.svg');
  }

  .icon-review {
    display: inline-block;
    margin-left: -2px;
    width: 24px;
    height: 24px;
    color: @grey-1;
    background-color: @grey-1;
    -webkit-mask: url('../../../static/img/event-needs-review.svg') no-repeat center;
    mask: url('../../../static/img/event-needs-review.svg') no-repeat center;
    background: url('../../../static/img/event-needs-review-grey.svg');
  }

  .icon-approved {
    display: inline-block;
    margin-left: -2px;
    width: 24px;
    height: 24px;
    color: @grey-1;
    background-color: @grey-1;
    -webkit-mask: url('../../../static/img/event-approved.svg') no-repeat center;
    mask: url('../../../static/img/event-approved.svg') no-repeat center;
    background: url('../../../static/img/event-approved-grey.svg');
  }

  .icon-archived {
    display: inline-block;
    margin-left: -2px;
    width: 22px;
    height: 22px;
    color: @grey-1;
    background-color: @grey-1;
    -webkit-mask: url('../../../static/img/event-archived.svg') no-repeat center;
    mask: url('../../../static/img/event-archived.svg') no-repeat center;
    background: url('../../../static/img/event-archived-grey.svg');
  }

  /* This is beginning for button in each line of event */

  .icon-duplicate {
    margin: 3.5px 3.5px;
    width: 24px;
    height: 24px;
    background-color: @white;
    -webkit-mask: url('../../../static/img/24px-action-copy.svg') no-repeat center;
    mask: url('../../../static/img/24px-action-copy.svg') no-repeat center;
    background: url('../../../static/img/24px-action-copy-white.svg');
  }

  .icon-delete {
    margin: 3.5px 3.5px;
    width: 24px;
    height: 24px;
    background-color: @white;
    -webkit-mask: url('../../../static/img/24px-action-trash.svg') no-repeat center;
    mask: url('../../../static/img/24px-action-trash.svg') no-repeat center;
    background: url('../../../static/img/24px-action-trash-white.svg');
  }

  .icon-submit {
    margin: 3.5px 3.5px;
    width: 24px;
    height: 24px;
    background-color: @white;
    -webkit-mask: url('../../../static/img/24px-export.svg') no-repeat center;
    mask: url('../../../static/img/24px-export.svg') no-repeat center;
    background: url('../../../static/img/24px-export-white.svg');
  }

  /* This is end for button in each line of event */

  .col-contact {
    color: @black;
    font-family: @font-family-main;
    font-size: 14px;
    line-height: 18px;
    border: 0 solid @grey-6;
    border-radius: 3px;
    // margin-left: 10px;
    width: 100%;
    background-color: @grey-5;
    z-index: 0;
    min-height: 0;

    .multiselect__select {
      display: none;
      width: 0;
      height: 0;
    }
    .multiselect__tags {
      margin-top: 15px;
      font-size: 14px;
      line-height: 18px;
      padding: 0;
      min-height: 0;
      border: none;
      z-index: unset;

      .multiselect__placeholder{
        &:extend(.label-text);
        color: @text-10;
      }

      .multiselect__input {
        &:extend(.label-text);
        border: none;
        color: @black;
        font-family: @font-family-main;
        background-color: @white;
        margin: 0;
        padding: 0;
      }
    }
    .multiselect__content-wrapper {
      z-index: 99;
      width: 300px;
      left: -80px;
      border: none;
      // border: 1px solid @grey-4;
      border-radius: 3px;
      margin-top: 5px;
      // padding: 0px 0 7px 0;
      // display: none;
      .multiselect__element {
        padding: 0 0 0 0px;
        .multiselect__option {
          &:extend(.label-text);
          padding: 0px;
          border-bottom: 1px solid @grey-4;
          .contact-detail {
            height: 58px;
            padding: 12px 20px;
            .contact-name-decoration {
              text-transform: capitalize;
            }
          }
        }

        .multiselect__option:first-child {
          // border-top: 1px solid @grey-4;
        }

        .multiselect__option--highlight {
          &::after {
            content: '';
          }
          color: @black;
          background-color: @grey-5;
        }
        .multiselect__option--selected {
          &::after {
            content: '';
          }
        }
      }
    }
  }

  // .fix-width{
  //   width: 100% !important;
  // }

  // /* FOR FIREFOX */
  // _:-moz-tree-row(hover), .fix-width{
  //   width: 96% !important;
  // }

  // // For safari
  // _::-webkit-full-page-media, _:future, :root .fix-width {
  //   width: 96% !important;
  // }

  .data-table-row-edit-mode-text {
    font-family: @font-family-main;
    border: 0 solid @grey-4;
    border-radius: 3px;
    width: 100%;
    min-height: 0;
    z-index: unset;
    height: 25px;
    color: #1D1D1D;
    font-size: 12px;
    line-height: 25px;

    .multiselect__select {
      display: none;
      width: 0;
      height: 0;
    }

    .multiselect__tags {
      margin-top: 15px;
      font-size: 14px;
      line-height: 18px;
      padding: 0;
      min-height: 0;
      border: none;
      z-index: unset;

      .multiselect__input {
        width: 100%;
        border: none;
        color: @black;
        font-family: @font-family-main;
        background-color: @grey-5;
        margin: 0;
        padding: 0 0 0 0px;
      }
    }
    .multiselect__content-wrapper {
      z-index: 99;
      // width: 110%;
      width: 86px;
      padding: 0 0 7px 0;
      .multiselect__element {
        border-bottom: 1px solid @grey-4;
        &:hover {
          background-color: @grey-5;
        }
        .multiselect__option {
          font-family: @font-family-main;
          font-size: 14px;
          line-height: 18px;
        }
        .multiselect__option--highlight {
          &::after {
            content: '';
          }
          color: @black;
          background-color: @grey-5;
        }
        .multiselect__option--selected {
          background: @white;
          color: @black;
          font-family: @font-family-main;
          &::after {
            content: '';
          }
          &:hover {
            color: @black;
            background-color: @grey-5;
          }
        }
      }
    }
  }

  .data-table-row-edit-mode-input-time-start-active {
    width: 137%;
    margin-left: -10px;
  }

  .data-table-row-edit-mode-expand-input-right {
    color: @grey-6;
    font-size: 14px;
    line-height: 18px;
    width: 160px;
    margin-right: 65px;
    background-color: @white;
  }

  .icon-actions {
    width: 25px;
    height: 25px;
    margin-left: -2px;
  }

  .exchange-icon {
    border: 2px solid @white;
    border-radius: 10px;
    box-sizing: border-box;
  }

  .func-icon-small {
    position: relative;
    top: 1px;
    width: 16px;
    height: 13px;
  }

  .data-table-icon-circle {
    width: 16px;
    height: 16px;
    float: left;
    margin-left: -8px;
    display: none;
    margin-top: 0px;
  }

  .data-table-row-edit-mode-input-small {
    width: 90%;
  }

  .data-table-input-contact-name {
    width: 93%;
  }

  .shipping-address {
    height: 34px;
    width: 100%;
    border: 1px solid @grey-4;
    border-radius: 3px;
    padding-left: 14px;
    color: @black;
  }

  .multiselect {
    min-height: 0 !important;
  }

  .circle-red {
    color: @red !important;
  }

  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;
  }

  input[type=number] {
    -moz-appearance: textfield;
  }

  .li-red {
    &:before {
      color: @red !important;
    }
  }

  .pac-container > .pac-item:first-child {
    margin-top: 7px;
    border-top: none;
  }

  .pac-container > .pac-item:last-child {
    margin-bottom: 7px;
  }

  .pac-container {
    border: 1px solid @grey-4;
    border-radius: 3px;
    .pac-item {
      padding: 0 0 0 20px;
      height: 36px;
      font-family: @font-family-main;
      font-size: 14px;
      &:hover {
        background-color: @grey-5;
      }
      .pac-icon {
        display: none;
      }
      .pac-matched {

      }
    }
  }

  .hdpi.pac-logo:after {
    background-image: none;
    height: 0;
  }

  .address-input {
    height: 18px;
    margin-top: 16px;
    padding: 0;
  }

  .padding-left-50 {
    padding-left: 50px;
  }

  .padding-left-22 {
    padding-left: 22px;
  }

  .event-add-on {
    overflow: hidden;

    .add-on-item-wrapper {
      // margin-left: -30px;
      // height: 110px;
    }
    .title {
      margin-top: 20px;
      // color: #fff;
      // background-color: #0080A5;
      .icon-add {
        color: #fff;
        background-color: #00A4D6;
        border: 3px;
        border-radius: 20px;
        width: 16px;
        height: 16px;
        margin-left: 15px;
      }
      .text {
        margin-left: 10px;
        color: #00A4D6;;
        font-family: "Open Sans", sans-serif;
        font-size: 12px;
        text-transform: capitalize;
      }
    }
    .add-on-item {
      width: 210px;
      position: relative;
      margin-left: 0;
      margin-top: 15px;
      display: inline-block;
      .text {
        position: absolute;
        left: 45px;
      }
    }
    input[type=checkbox] {
      height: 0;
      width: 0;
      visibility: hidden;
    }

    label {
      float: left;
      cursor: pointer;
      text-indent: -9999px;
      width: 32px;
      height: 18px;
      background: #fff;
      border-radius: 15.5px;
      position: relative;
      top: 1.5px;
      left: 0px;
      border: 1.5px solid rgba(0, 0, 0, 0.1);
      margin-bottom: 0;
    }

    label:after {
      content: '';
      position: absolute;
      top: -0.5px;
      left: -0.5px;
      width: 16px;
      height: 16px;
      background: #fff;
      border-radius: 15.5px;
      -webkit-transition: 0.3s;
      transition: 0.3s;
      border: 1px solid rgba(0, 0, 0, 0.1);
    }

    input:checked + label {
      background: #00A4D6;
      border: 1.5px solid #00A4D6;
      // border: none;
    }

    input:checked + label:after {
      // top: -0.5px;
      left: calc(100% - 0px);
      transform: translateX(-100%);
      box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);
    }

    label:active:after {
      width: 15px;
    }
  }

  .hover-pointer:hover {
    cursor: pointer;
  }

  .show-dropdown {
    .place-holder{
      .dropdown-toggle{
        color: @text-10;
      }
    }
    .dropdown-menu {
      display: block;
      min-width: 64%;
      width: 100%;
      height: 230px;
      overflow-y: scroll;
      top: 52px;
      & > li > a {
        height: 45px;
        color: #1D1D1D;
        font-family: "Open Sans", sans-serif;
        font-size: 16px;
        line-height: 24px;
        border-bottom: solid 1px #e6e6e6;
        padding: 12px 0 9px;
        margin-left: 5px;
      }
    }
    li.dropdown-toggle {
      height: 100%;
      min-width: 100%;
      background-image: none;
      color: #1D1D1D;
      font-size: 12px;
      font-weight: normal;
      line-height: 16px;

      &::after {
        display: none;
      }
      &:hover {
        background: #FFFFFF;
      }
    }
    .btn-group {
      min-width: 100%;
      margin: 0;
    }

    span.caret {
      display: none;
    }
  }

  .show-dropdown-for-arrival-time {
    margin-top: 6px;
    .dropdown-menu {
      display: block;
      min-width: 94px;
      width: 100%;
      height: 230px;
      overflow-y: scroll;
      top: 25px;
      & > li > a {
        height: 45px;
        color: #1D1D1D;
        font-family: "Open Sans", sans-serif;
        font-size: 16px;
        line-height: 24px;
        border-bottom: solid 1px #e6e6e6;
        padding: 12px 0 9px;
        margin-left: 5px;
      }
    }
    li.dropdown-toggle {
      height: 100%;
      min-width: 100%;
      background-image: none;
      color: #1D1D1D;
      font-size: 12px;
      font-weight: bold;
      line-height: 16px;

      &::after {
        display: none;
      }
      &:hover {
        background: #FFFFFF;
      }
    }
    .btn-group {
      min-width: 100%;
      margin: 0;
    }

    span.caret {
      top: 7px;
      margin-left: 7px;
    }
  }

  .notes-field {
    .add-on-wrapper {
      float: left;
      height: 22px;
      line-height: 22px;
      .add-on-item {
        .text {
          color: @black-2;
          font-family: "Open Sans", serif;
          font-size: 12px;
          display: inline;
          margin-left: -10px;
        }
        .title {
          margin-left: 8px !important;
          &.active {
            color: #00A4D6;
            font-family: "Open Sans", sans-serif;
            font-size: 12px;
            font-weight: bold;
            line-height: 16px;
          }
        }
        input[type=checkbox] {
          height: 0;
          width: 0;
          visibility: hidden;
        }
        label {
          cursor: pointer;
          text-indent: -9999px;
          width: 32px;
          height: 18px;
          background: #fff;
          border-radius: 15.5px;
          position: relative;
          top: 1.5px;
          left: 5px;
          border: 1.5px solid rgba(0, 0, 0, 0.1);
          margin-bottom: 0;
        }

        label:after {
          content: '';
          position: absolute;
          top: -0.5px;
          left: -0.5px;
          width: 16px;
          height: 16px;
          background: #fff;
          border-radius: 15.5px;
          -webkit-transition: 0.3s;
          transition: 0.3s;
          border: 1.5px solid rgba(0, 0, 0, 0.1);

        }

        input:checked + label {
          background: #00A4D6;
          border: 1.5px solid #00A4D6;
        }

        input:checked + label:after {
          left: calc(100% - 0px);
          transform: translateX(-100%);
          box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);
        }

        label:active:after {
          width: 15px;
        }
      }
    }
    .arrival-time {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }
  .title-text {
    color: #1D1D1D;
    font-family: "Open Sans";
    font-size: 12px;
    font-weight: bold;
    line-height: 16px;
  }

  .overflow-show {
    span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
</style>



// WEBPACK FOOTER //
// DataTableRowEditMode.vue?58012c58